 
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuIdDocument = gql`
    query GetMenuId($typeMenu: MenuTypeType, $branchId: Int!) {
  menu(type: $typeMenu, branchId: $branchId) {
    id
    status {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetMenuIdQuery__
 *
 * To run a query within a React component, call `useGetMenuIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuIdQuery({
 *   variables: {
 *      typeMenu: // value for 'typeMenu'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetMenuIdQuery(baseOptions: Apollo.QueryHookOptions<GetMenuIdQuery, GetMenuIdQueryVariables> & ({ variables: GetMenuIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuIdQuery, GetMenuIdQueryVariables>(GetMenuIdDocument, options);
      }
export function useGetMenuIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuIdQuery, GetMenuIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuIdQuery, GetMenuIdQueryVariables>(GetMenuIdDocument, options);
        }
export function useGetMenuIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuIdQuery, GetMenuIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuIdQuery, GetMenuIdQueryVariables>(GetMenuIdDocument, options);
        }
export type GetMenuIdQueryHookResult = ReturnType<typeof useGetMenuIdQuery>;
export type GetMenuIdLazyQueryHookResult = ReturnType<typeof useGetMenuIdLazyQuery>;
export type GetMenuIdSuspenseQueryHookResult = ReturnType<typeof useGetMenuIdSuspenseQuery>;
export type GetMenuIdQueryResult = Apollo.QueryResult<GetMenuIdQuery, GetMenuIdQueryVariables>;
export type GetMenuIdQueryVariables = Types.Exact<{
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetMenuIdQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', id: number, status: { __typename?: 'MenuStatusProxy', id: number, slug: string, name: string } } };
